<ft-modal-editor-wrapper>
    <ng-template #triggerTmpl>
        <ng-content />
    </ng-template>
    <div class="ft2-edit-dialog_modal p-0 ft-code-editor-shell"
         [style.height]="height + 'px'"
         [style.width]="'95vw'"
         [style.max-width]="'768px'">
        <ng-container *ngIf="visible">
            <div class="ft-code-editor-shell_toolbar">
                <button class="ft2-btn-pure p-1" type="button" title="Format document" (click)="formatContent()">
                    Format
                </button>
            </div>
            <ft-code-mirror class="ft-code-editor-shell_editor"
                            [(ngModel)]="value"
                            [required]="required"
                            #control="ngModel"
                            [language]="language"
                            (ready)="onEditorReady($event)" />
        </ng-container>
    </div>
</ft-modal-editor-wrapper>
